import React from 'react';
import CustomButton from '../ui/Button';
import { useSolutionDropdown } from '../hooks/SolutionDropdownContext';
import { useTranslation } from "react-i18next";




const HeroSection = () => {
    const { toggleDropdown } = useSolutionDropdown();
    const { t,i18n } = useTranslation("services");
    const isRussian = i18n.language === "ru"; // Check if the language is Russian



    return (
        <div className="relative h-[811px] md:h-[592px]">
            <img
                src="/assets/servicesbg.svg"
                className="w-full h-full object-cover"
                alt="background animation"
            />
            <div className="absolute inset-0 bg-[#00000099]"></div>
            <img
                src="/assets/ellipse.svg"
                className="absolute bottom-64 left-1/2 transform -translate-x-1/2 translate-y-1/2"
                alt="ellipse decoration"
            />
            <div className="absolute inset-0 flex flex-col items-center justify-center text-white text-center px-2 md:px-4 mb-16">
                {/* Welcome Text */}
                <div className="title-small text-[#05897E] py-2 px-4 rounded-full mb-4 border border-[#FFFFFF33]">
                    {t("service")}
                </div>
                <div className='max-w-[818px]'>
                    {/* Main Heading */}
                    <h1 className={`web-heading-main mb-4 ${isRussian ? 'lang-ru-web-heading-main' : ''}`}>

                        {t("service_subheading")}
                    </h1>
                    {/* Description */}
                        <p className={`text-color body-large-30 mb-6 md:text-xl max-w-5xl ${isRussian ? 'lang-ru-body-large-30' : ''}`}>
                        {t("service_description")}
                    </p>
                </div>
                {/* Buttons */}
                <div className="flex flex-col md:flex-row gap-4">
                    <CustomButton onClick={toggleDropdown} >
                        <div className="flex items-center justify-center gap-2">
                            {t("explore_solution")}
                        </div>
                    </CustomButton>
                    <CustomButton transparent>
                        <a href="/contact_us">
                            <div className="flex items-center justify-center gap-2">
                                {t("start_free_trial")}
                            </div>
                        </a>
                    </CustomButton>
                </div>
            </div>
        </div>
    );
};

export default HeroSection;